import React from 'react'
import PropTypes from 'prop-types'
import { Button, Popup } from 'semantic-ui-react'
import useModal from 'hooks/useModal'

export const LiveButton = ({ className, loading, isButtonDisabled, createOnSetSurveyLive }) => {
  const { Modal, open, close } = useModal()
  return (
    <React.Fragment>
      <Popup
        basic
        wide
        disabled={!isButtonDisabled}
        trigger={
          <Button.Group color="green" className={className}>
            <Button onClick={open} disabled={isButtonDisabled}>
              <i className="far fa-circle-play icon" />
              Set Live
            </Button>
          </Button.Group>
        }
      >
        <React.Fragment>
          <p>Please correct the following before sending:</p>
          <ul>
            <li>Save latest changes</li>
            <li>Create at least one audience rule</li>
            <li>Ensure survey expiration settings are correct</li>
          </ul>
        </React.Fragment>
      </Popup>
      <Modal size="tiny">
        <Modal.Header>Set your survey live</Modal.Header>
        <Modal.Content>
          You are about to make this survey live for customers who match the delivery settings.
          We'll also send to future customers who enter the audience. Do you wish to continue?
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={close}>Cancel</Button>
          <Button color="green" onClick={createOnSetSurveyLive(close)} loading={loading}>
            <i className="far fa-circle-play icon" />
            Set Live
          </Button>
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  )
}

LiveButton.propTypes = {
  loading: PropTypes.bool.isRequired,
  isButtonDisabled: PropTypes.bool.isRequired,
  createOnSetSurveyLive: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/LiveButton.js